import { extractParams } from '@zapier/url-utils';

import { isBrowser } from '@zapier/promotions/src/utils';

export const getOfferIdFromUrl = () => {
  let offerIdFromUrl;

  if (isBrowser()) {
    const { offer_id } = extractParams(window.location.href);
    offerIdFromUrl = offer_id;
  }

  return offerIdFromUrl;
};
